import React from 'react'
import {Flex} from './layout'
import SectionLink from './_SectionLink'
import SectionLinkSoon from './_SectionLinkSoon'
import Superface from '../Superface'

export default class Interface extends React.Component {

    state = {
        lang : 0
    }
    
    constructor(props){
        super(props)
        this.handleResize = this.handleResize.bind(this)
    }

    componentDidMount(){
        window.addEventListener('resize', this.handleResize)
    }
    
    componentWillUnmout(){
        if(this.timeoutMount) clearTimeout(this.timeoutMount)
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize(){
        this.setState({})
    }

    renderContact(){
        if(this.props.showContact) return <Contact />
    }

    render(){
        if( !Superface.datas().contact ) return <span></span>

        const windowRatio = window.innerWidth / window.innerHeight
        
        const style = {
            width:'calc(100% - 4rem)',
            height:'calc(100% - 4rem)',
            position:'absolute',
            zIndex:900,
            padding:'2rem'
        }

        const widthLinkBottom = ( Superface.IS_MOBILE ? '100px' : '150px' )

        return(
            
            <Flex id="interface" direction='column' justify='space-between' style={style}>
                
                <Flex style={{height:'33%'}} align='flex-start' justify='space-between'>
                    
                    <div style={{width:'150px', textAlign:'left'}}></div>

                    <SectionLink 
                        to={ Superface.uri('contact') }
                        align='center'
                        >
                        { Superface.translate('Contact') }
                    </SectionLink>


                    <div id='mail' style={{width:'150px'}}></div>

                </Flex>
                
                <Flex style={{height:'33%'}} align='center' justify='space-between'>
                    
                    <SectionLink 
                        to={ Superface.uri('matieres') }
                        align={ windowRatio < 1  ? 'center' : 'left'}
                        rotate={ windowRatio < 1  ? 'rotate(-90deg)' : 'rotate(0deg)' }
                        margin={ windowRatio < 1  ? '0 0 0 -7rem' : 0 }
                        >
                        { Superface.translate('Matières') }
                    </SectionLink>

                    <SectionLinkSoon
                        align={ windowRatio < 1  ? 'center' : 'right'}
                        rotate={ windowRatio < 1  ? 'rotate(90deg)' : 'rotate(0deg)' }
                        margin={ windowRatio < 1  ? '0 -7rem 0 0' : 0 }
                        >
                        { Superface.translate('Projets') }
                    </SectionLinkSoon>
                    
                </Flex>

                <Flex style={{height:'33%'}} align='flex-end' justify='space-between'>

                    <div id='languages' style={{width:widthLinkBottom, textAlign:'left', cursor:'pointer', color:'white'}}>
                        <span style={{ textDecoration : Superface.getLang() !== 'fr' ? 'none' : 'line-through'}} onClick={ (e) => { Superface.setLang('fr') }}>Fr</span>
                        &nbsp;&nbsp;&nbsp;
                        <span style={{ textDecoration : Superface.getLang() !== 'en' ? 'none' : 'line-through'}} onClick={ (e) => { Superface.setLang('en') }}>En</span>
                    </div>
                    
                    <SectionLink 
                        to={ Superface.uri('notre-metier') }
                        align='center'
                        >
                        { Superface.translate('Notre métier') }
                    </SectionLink>

                    <div style={{ width: widthLinkBottom, textAlign:'right'}}>
                        <a className="icon" href={ Superface.datas().contact.facebook } target="_blank">
                            <img src={require('../images/facebook.svg')} alt="facebook"/>
                        </a>
                        
                        <a className="icon" href={ Superface.datas().contact.instagram  } target="_blank">
                            <img src={require('../images/instagram.svg')} alt="instagram"/>
                        </a>
                    </div>

                </Flex>

            </Flex>
            
        )

    }
}



const Contact = (props) => {
    return(
        <a  style={{width:'1.5rem',height:'1.5rem', display:'inline-block'}} href="mailto:mail@superface.fr"><img src={require('../images/mail-black.svg')} alt="email"/> </a>
    )
}



// WEBPACK FOOTER //
// ./src/components/HomeInterface.js